/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import { Header, Segment, } from 'semantic-ui-react'
import LoadingPlaceholder from '../../placeholderComponent/loadingPlaceholder'
import ReadAxios from '../../axiosComponent/read'
import VendorTypeActionButton from './vendorTypeActionButton';
import AgGridTable from '../../agGridComponent/agGridTable';
import Axios from 'axios';
import APP_CONSTANTS from '../../../config/constants';
import { FEATURES } from '../../../utils/constants';

function VendorTypeTable(props) {
  const [vendorTypes, setvendorTypes] = useState([])
  const [isLoaded, setisLoaded] = useState(false)
  const [isUpdated, setisUpdated] = useState(false)
  useEffect(() => {
    getData()
  }, [isUpdated])

  let getData = () => {
    Axios.get(`${APP_CONSTANTS.BASE_URL}/masters/vendorType`)
    // ReadAxios({ url: 'masters/vendorType/2' }).then((result) => {
    //   setvendorTypes(result)
    //   setisLoaded(true)
    // })
  }
  let getUpdate = (data) => {
    if (data) {
      setisUpdated(!isUpdated)
    }
  }

  /* if (vendorTypes && vendorTypes.length === 0 && isLoaded === false) {
      return (
          <LoadingPlaceholder />
      )
  } else if ((vendorTypes) && vendorTypes.length === 0) {
      return (
          <Segment className="m-2">
              <center> <Header>NO Record(s) Found</Header></center>
          </Segment>
      )
  } else { */

  let columnDefs = [
    { headerName: 'Vendor Type Code', field: 'code', tooltipField: 'code', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: 'Vendor Type', field: 'name', tooltipField: 'name', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: 'Created By', field: 'cby', tooltipField: 'cby', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: 'Created Date', field: 'cdate', tooltipField: 'cdate', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: 'Updated By', field: 'uby', tooltipField: 'uby', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: 'Updated Date', field: 'udate', tooltipField: 'udate', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: 'Edit / Delete', field: 'edit', cellRenderer: 'actionRenderer' },
  ]
  let rowData = [];

  (vendorTypes != null && vendorTypes != undefined) && vendorTypes.map((object, i) => {
    let temp = {}
    temp.code = object.vendorTypeCode
    temp.name = object.vendorType
    temp.cby = object.createdByName
    temp.id = object.vendorTypeId
    temp.cdate = object.createdOn
    temp.uby = object.updatedByName
    temp.udate = object.updatedOn
    temp.customerNo = object.customerNo
    rowData[i] = temp
  })
  return (
    <React.Fragment >
      <AgGridTable
        columnDefs={columnDefs}
        rowData={rowData}
        searchValue={props.searchValue}
        actionButton={VendorTypeActionButton}
        reload={getUpdate}
        link="#"
        hiddenNew={true}
        newPopup={props.newPopup}
        titleBarTitle="Vendor Type"
        handleSearch={props.handleSearch}
        hiddenImportPopupBtn={true}
        exportHidden={FEATURES.mastersExportDisabled()}
        suppressExcelExport={FEATURES.mastersExportDisabled()}
        suppressCsvExport={FEATURES.mastersExportDisabled()}
      />
    </React.Fragment>
  )
}

//}

export default VendorTypeTable
